import React,{useState} from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import GraphIcon from "../../../icons/Graphicon.png";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Chart from 'react-google-charts';
import DialogContentText from '@mui/material/DialogContentText';
import CloseIcon from '@mui/icons-material/Close';
import { DialogTitle } from '@mui/material';
import axios from "../../../utils/fvAxios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";



const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.action.hover,

    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({

    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


export default function PMDashboard({pm,pqID}) {
    const Pm = pm?.item1 || []; // Ensure Pm is an array
    const pM = pm?.item2 || {}; // Ensure pM is an object

    function createData(name, name1, name2, name3, name4, name5) {
        return { name, name1, name2, name3, name4, name5 };
    }

    function createData1(name, name1, name2, name3) {
        return { name, name1, name2, name3 };
    }

    function createData2(name, name1, name2, name3, name4) {
        return { name, name1, name2, name3, name4 };
    }

    const row = [
        createData('Current Ratio', '(Cash & Receivables Current Liabilities)', Pm[0]?.currentRatio || '', Pm[1]?.currentRatio || '', Pm[2]?.currentRatio || '', Pm[3]?.currentRatio || ''),
        createData('Quick Ratio', '(Cash & receivables/Current liabilities)', Pm[0]?.quickRatio || '', Pm[1]?.quickRatio || '', Pm[2]?.quickRatio || '', Pm[3]?.quickRatio || ''),
        createData('Working Capital to Revenue', '(Working Capital Revenue)', Pm[0]?.workingCapitalRevenue + "%" || '', Pm[1]?.workingCapitalRevenue + "%" || '', Pm[2]?.workingCapitalRevenue + "%" || '', Pm[3]?.workingCapitalRevenue + "%" || ''),
        createData('Days Cash', '(Cash x 360 Revenue)', Pm[0]?.daysCash || '', Pm[1]?.daysCash || '', Pm[2]?.daysCash || '', Pm[3]?.daysCash || ''),
        createData('Return on Equity (ROE)', '(Net Income (loss) Shareholders Equity)', Pm[0]?.returnEquity || '', Pm[1]?.returnEquity + "%" || '', Pm[2]?.returnEquity + "%" || '', Pm[3]?.returnEquity + "%" || ''),
        createData('Net Profit Margin', '(Net Profit Revenue)', Pm[0]?.netProfitMargin + "%" || '', Pm[1]?.netProfitMargin + "%" || '', Pm[2]?.netProfitMargin + "%" || '', Pm[3]?.netProfitMargin + "%" || ''),
    ];

    const emrValues = pM?.emr?.split(',') || []; // Split the "emr" string into an array
    const rirValues = pM?.rir?.split(',') || []; // Split the "rir" string into an array
    const dartValues = pM?.dart?.split(',') || []; // Split the "dart" string into an array

    const row2 = [
        createData2('EMR', '(Must be below 1.0)', emrValues[0] || '', emrValues[1] || '', emrValues[2] || ''),
        createData2('RIR', '(Must be below 5.0)', rirValues[0] || '', rirValues[1] || '', rirValues[2] || ''),
        createData2('DART', '(Must be below 5.0)', dartValues[0] || '', dartValues[1] || '', dartValues[2] || ''),
    ];

    const row1 = [
        createData1('Current Ratio', Pm[0]?.currentAssets || '', Pm[0]?.currentLiabilities || '', Pm[0]?.currentRatio || ''),
        createData1('Quick Ratio', Pm[0]?.cashReceivables || '', Pm[0]?.currentLiabilities || '', Pm[0]?.quickRatio || ''),
        createData1('Working Capital to Revenue', Pm[0]?.workingCapital || '', Pm[0]?.revenue || '', Pm[0]?.workingCapitalRevenue + "%" || ''),
        createData1('Days Cash', Pm[0]?.cashX360 || '', Pm[0]?.revenue || '', Pm[0]?.daysCash || ''),
        createData1('Return on Equity (ROE)', Pm[0]?.netIncome || '', Pm[0]?.shareholderEquity || '', Pm[0]?.returnEquity + "%" || ''),
        createData1('Net Profit Margin', Pm[0]?.netIncome || '', Pm[0]?.revenue || '', Pm[0]?.netProfitMargin + "%" || ''),
    ];

    const rows2 = [
        createData1('Current Ratio', Pm[1]?.currentAssets || '', Pm[1]?.currentLiabilities || '', Pm[1]?.currentRatio || ''),
        createData1('Quick Ratio', Pm[1]?.cashReceivables || '', Pm[1]?.currentLiabilities || '', Pm[1]?.quickRatio || ''),
        createData1('Working Capital to Revenue', Pm[1]?.workingCapital || '', Pm[1]?.revenue || '', Pm[1]?.workingCapitalRevenue + "%" || ''),
        createData1('Days Cash', Pm[1]?.cashX360 || '', Pm[1]?.revenue || '', Pm[1]?.daysCash || ''),
        createData1('Return on Equity (ROE)', Pm[1]?.netIncome || '', Pm[1]?.shareholderEquity || '', Pm[1]?.returnEquity + "%" || ''),
        createData1('Net Profit Margin', Pm[1]?.netIncome || '', Pm[1]?.revenue || '', Pm[1]?.netProfitMargin + "%" || ''),
    ];

    const row3 = [
        createData1('Current Ratio', Pm[2]?.currentAssets || '', Pm[2]?.currentLiabilities || '', Pm[2]?.currentRatio || ''),
        createData1('Quick Ratio', Pm[2]?.cashReceivables || '', Pm[2]?.currentLiabilities || '', Pm[2]?.quickRatio || ''),
        createData1('Working Capital to Revenue', Pm[2]?.workingCapital || '', Pm[2]?.revenue || '', Pm[2]?.workingCapitalRevenue + "%" || ''),
        createData1('Days Cash', Pm[2]?.cashX360 || '', Pm[2]?.revenue || '', Pm[2]?.daysCash || ''),
        createData1('Return on Equity (ROE)', Pm[2]?.netIncome || '', Pm[2]?.shareholderEquity || '', Pm[2]?.returnEquity + "%" || ''),
        createData1('Net Profit Margin', Pm[2]?.netIncome || '', Pm[2]?.revenue || '', Pm[2]?.netProfitMargin + "%" || ''),
    ];

    const row4 = [
        createData1('Current Ratio', Pm[3]?.currentAssets || '', Pm[3]?.currentLiabilities || '', Pm[3]?.currentRatio || ''),
        createData1('Quick Ratio', Pm[3]?.cashReceivables || '', Pm[3]?.currentLiabilities || '', Pm[3]?.quickRatio || ''),
        createData1('Working Capital to Revenue', Pm[3]?.workingCapital || '', Pm[3]?.revenue || '', Pm[3]?.workingCapitalRevenue + "%" || ''),
        createData1('Days Cash', Pm[3]?.cashX360 || '', Pm[3]?.revenue || '', Pm[3]?.daysCash || ''),
        createData1('Return on Equity (ROE)', Pm[3]?.netIncome || '', Pm[3]?.shareholderEquity || '', Pm[3]?.returnEquity + "%" || ''),
        createData1('Net Profit Margin', Pm[3]?.netIncome || '', Pm[3]?.revenue || '', Pm[3]?.netProfitMargin + "%" || ''),
    ];
    const [apiData1, setDeFault] = useState([]);
    const apiData = {
        // series: [
        //   {
        //     name: "Valdez Painting, Inc.",
        //     data: [
        //       1.7746944136247322,
        //       1.9355676243506288,
        //       1.5000791438655108,
        //       1.5769561049562821
        //     ]
        //   },
        //   {
        //     name: "Painting",
        //     data: [
        //       3.0410187003668376,
        //       3.5937677304626745,
        //       3.722217758143731,
        //       3.2892661370734553
        //     ]
        //   }
        // ],
        // categoryAxis: [
        //   "Current Year",
        //   "Previous Year",
        //   "2 Years Previous",
        //   "3 Years Previous"
        // ]
      };
      const [data, setData] = useState([]);
      const [isDataLoaded, setIsDataLoaded] = useState(false);
      const [isDataLoading, setIsDataLoading] = useState(false);
      
    const handleChange = (e) => {
       
        setIsDataLoading(true)
      const stringWithoutBrackets = e.name.replace(/\s*\(.*?\)\s*/g, '');
  
      // Step 2: Remove all spaces
      const cleanedString = stringWithoutBrackets.replace(/\(.*?\)/g, '');
      const text=stringWithoutBrackets.replace(/\s+/g, '')
   
      const getMappedValue = (text) => {
        switch (text) {
          case "CurrentRatio":
            return "CurrentRatio";
          case "QuickRatio":
            return "QuickRatio";
          case "WorkingCapitaltoRevenue":
            return "WorkingCapitalPercentageRevenue";
          case "DaysCash":
            return "DaysCash";
          case "ReturnonEquity":
            return "AfterTaxReturnCurrentEquity";
          case "NetProfitMargin":
            return "NetProfitMargin";
          default:
            return "No Match Found";
        }
      };
      const result = getMappedValue(text)
        axios.get("Prequalification/LoadGraphInPMDashBoard?PQId="+pqID+"&field="+result).then((res) => {
            if (res?.data?.status === true) {
            //   setstatuses(res?.data?.data);
            setDeFault(res?.data?.data)
       
            if (res?.data?.data && res?.data?.data.series && res?.data?.data.series.length > 1 && res?.data?.data.categoryAxis) {
                const dataArray = [
                  ['Year', res?.data?.data.series[0].name, res?.data?.data.series[1].name],
                  [res?.data?.data.categoryAxis[0], res?.data?.data.series[0].data[0], res?.data?.data.series[1].data[0]],
                  [res?.data?.data.categoryAxis[1], res?.data?.data.series[0].data[1], res?.data?.data.series[1].data[1]],
                  [res?.data?.data.categoryAxis[2], res?.data?.data.series[0].data[2], res?.data?.data.series[1].data[2]],
                  [res?.data?.data.categoryAxis[3], res?.data?.data.series[0].data[3], res?.data?.data.series[1].data[3]],
                ];
                setData(dataArray);
           
                setIsDataLoaded(true);
              }
            setOpenpop(true);
            } else {
              alert(res.data.responseMessage);
            }
          })  .finally(() => {
            setIsDataLoading(false);
          });
      };
      const handleChange1 = () => {
        setOpenpop(false);

     
      };
      const [openpop, setOpenpop] = React.useState(false);
    //   const data = [
    //     ['Year', 'Valdez Painting, Inc.', 'Painting'],
    //     [apiData?.categoryAxis[0], apiData?.series[0]?.data[0], apiData?.series[1]?.data[0]],
    //     [apiData?.categoryAxis[1], apiData?.series[0]?.data[1], apiData?.series[1]?.data[1]],
    //     [apiData?.categoryAxis[2], apiData?.series[0]?.data[2], apiData?.series[1]?.data[2]],
    //     [apiData?.categoryAxis[3], apiData?.series[0]?.data[3], apiData?.series[1]?.data[3]],
    //   ];
    
      const options = {
        title: '',
        intervals: { style: "points", pointSize: 4 },
        hAxis: {
          title: 'Year',
        },
        vAxis: {
          title: 'Value',
        },
      };
    return (
        <>
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isDataLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
            <Box

            >
                 <Dialog open={openpop} onClose={handleChange1} sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "700px",
            },
          },
        }}>
          
                 <DialogContentText sx={{
            textAlign: "center",
            fontWeight: 500,
            fontSize: 18,
          }}>
            {/* <p  >Note: Payment cannot be carried forward.</p> */}
        
  <span style={{float:"right" ,marginRight:"5px",cursor:"pointer"}} onClick={handleChange1}><CloseIcon/></span>
          </DialogContentText>
          <DialogTitle>{apiData1?.fieldName}:Bidding Interest Comparison to System Average</DialogTitle>
      <DialogContent sx={{cursor:"grab"}}>
      {/* {JSON.stringify(deFault)} */}
      <Chart
        chartType="LineChart"
        width="100%"
        height="400px"
        data={data}
        options={options}
      />
      </DialogContent>
    </Dialog>
   
                <TableContainer component={Paper} hidden={Pm?.length==0}>
                    <Table sx={{ minWidth: 700 }}  aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell className='text-muted'>{Pm[0]?.formattedValue}</StyledTableCell>
                                <StyledTableCell className='text-muted'>{Pm[1]?.formattedValue}</StyledTableCell>
                                <StyledTableCell className='text-muted'>{Pm[2]?.formattedValue}</StyledTableCell>
                                <StyledTableCell className='text-muted'>{Pm[3]?.formattedValue}</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {row?.map((row) => (
                                <StyledTableRow >
                                    <StyledTableCell scope="row">
                                        {row?.name}<br />{row?.name1}
                                    </StyledTableCell>

                                    <StyledTableCell align="left" > {row?.name2} </StyledTableCell>
                                    <StyledTableCell align="left" > {row?.name3} </StyledTableCell>
                                    <StyledTableCell align="left" > {row?.name4} </StyledTableCell>
                                    <StyledTableCell align="left" > {row?.name5}</StyledTableCell>
                                    <StyledTableCell align="left" style={{color:"#2A93DB",cursor:"pointer"}} onClick={()=>handleChange(row)} ><img src={GraphIcon} alt="Graph Icon" /> See Graph</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <TableContainer component={Paper} className='mt-3'>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell className='text-muted' align='center'>Current Year</StyledTableCell>
                                <StyledTableCell className='text-muted' align='center'>One Year Previous</StyledTableCell>
                                <StyledTableCell className='text-muted' align='center'>Two Years Previous</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {row2?.map((row) => (
                                <StyledTableRow key={row?.name}>
                                    <StyledTableCell > {row?.name}<br /> {row?.name1}</StyledTableCell>
                                    <StyledTableCell align='center' style={{ backgroundColor: "#ECFDF3" }}> {row?.name2} </StyledTableCell>
                                    <StyledTableCell align='center' style={{ backgroundColor: "#ECFDF3" }}> {row?.name3} </StyledTableCell>
                                    <StyledTableCell align='center' style={{ backgroundColor: "#ECFDF3" }}>{row?.name4}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>


                <TableContainer component={Paper} className='mt-3' hidden={Pm?.length==0}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell className='text-muted' sx={{ width: "679px" }}>{Pm[0]?.formattedValue}</StyledTableCell>
                                <StyledTableCell className='text-muted'>Title</StyledTableCell>
                                <StyledTableCell className='text-muted' align='right'>Title</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {row1?.map((row) => (
                                <StyledTableRow key={row?.name}>
                                    <StyledTableCell > {row?.name} </StyledTableCell>
                                    <StyledTableCell > {row?.name1?.toLocaleString("en-US")}    <hr style={{margin:0,color:"black",borderTop:"2px solid black",width:"75px"}}/> {row?.name2?.toLocaleString("en-US")}</StyledTableCell>
                                    <StyledTableCell align='right'>{row?.name3}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell className='text-muted' sx={{ width: "679px" }}>{Pm[1]?.formattedValue}</StyledTableCell>
                                <StyledTableCell className='text-muted'>Title</StyledTableCell>
                                <StyledTableCell className='text-muted' align='right'>Title</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows2?.map((row) => (
                                <StyledTableRow key={row?.name}>
                                    <StyledTableCell > {row?.name} </StyledTableCell>
                                    <StyledTableCell > {row?.name1?.toLocaleString("en-US")}    <hr style={{margin:0,color:"black",borderTop:"2px solid black",width:"75px"}}/> {row?.name2?.toLocaleString("en-US")}</StyledTableCell>
                                    <StyledTableCell align='right'>{row?.name3}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell className='text-muted' sx={{ width: "679px" }}>{Pm[2]?.formattedValue}</StyledTableCell>
                                <StyledTableCell className='text-muted'>Title</StyledTableCell>
                                <StyledTableCell className='text-muted' align='right'>Title</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {row3?.map((row) => (
                                <StyledTableRow key={row?.name}>
                                    <StyledTableCell > {row?.name} </StyledTableCell>
                                    <StyledTableCell > {row?.name1?.toLocaleString("en-US")}    <hr style={{margin:0,color:"black",borderTop:"2px solid black",width:"75px"}}/> {row?.name2?.toLocaleString("en-US")}</StyledTableCell>
                                    <StyledTableCell align='right'>{row?.name3}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell className='text-muted' sx={{ width: "679px" }}>{Pm[3]?.formattedValue}</StyledTableCell>
                                <StyledTableCell className='text-muted'>Title</StyledTableCell>
                                <StyledTableCell className='text-muted' align='right'>Title</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {row4?.map((row) => (
                                <StyledTableRow key={row?.name}>
                                    <StyledTableCell > {row?.name} </StyledTableCell>
                                    <StyledTableCell > {row?.name1?.toLocaleString("en-US")}    <hr style={{margin:0,color:"black",borderTop:"2px solid black",width:"75px"}}/> {row?.name2?.toLocaleString("en-US")}</StyledTableCell>
                                    <StyledTableCell align='right'>{row?.name3}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>


                    </Table>
                </TableContainer>
            </Box>
        </>
    )
}